__webpack_require__.p = "https://hospital-new-stage.curebay.in/";